<template>
  <div>
    <v-progress-linear
      :active="progressActive"
      :indeterminate="progressIndeterminate"
      color="primary"
      background-color="secondary"
      class="progressbar"
      :height="progBarHeight"
    >
    </v-progress-linear>
    <v-card
      flat
      class="list-container"
      :max-height="maxHeight"
    >
      <slot v-for="item in data" :tile="item"></slot>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'fact-sheet-sip',
  props: ['data', 'maxHeight', 'progressActive', 'progressIndeterminate', 'progBarHeight']
}
</script>

<style scoped lang="css">
  .progressbar {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FactSheet_Sip.vue